import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

class HeaderAccessItem extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.state = {
            isOpened: false
        };
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isOpened && !prevState.isOpened) {
            this.props.setOpened(this.props.type);
        }

        if (this.props.openedElem !== prevProps.openedElem) {
            this.setState({isOpened: this.props.openedElem === this.props.type});
        }
    };

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick, false);
    }

    handleClick() {
        if (!this.state.isOpened) {
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState({isOpened: !this.state.isOpened});
    }

    handleOutsideClick(e) {
        if (!this.node) return;
        if (this.node.contains(e.target));
        this.handleClick();
    };

    render() {
        const { type, clang, setFontSize, cfont, setContrast, contrast } = this.props;
        const { isOpened } = this.state;
        return (
            <div className="header__access-item">
                <button className={`header__access-button${type ? `--${type}` : ''}`}
                        title={
                              type === 'font' && cfont === 'normal' ? `${lang[clang].font_default_text}`
                            : type === 'font' && cfont === 'medium' ? `${lang[clang].font_medium_text}`
                            : type === 'font' && cfont === 'big' ?  `${lang[clang].font_big_text}`
                            : type === 'contrast' && contrast === 'normal' ? `${lang[clang].contrast_default_text}`: `${lang[clang].contrast_black_yellow_text}`
                        }
                        onClick={() => this.handleClick()}>
                </button>
                {isOpened &&
                    <div className={`header__access-dropdown${type ? `--${type}` : ''}`}>
                        {type === 'font' &&
                            <ul className="header__access-list" ref={node => { this.node = node; }}>
                                <span className="header__access-circle"></span>
                                <li className="header__access-list--item">
                                  <button onClick={() => setFontSize('normal')}
                                  title={lang[clang].font_default}
                                  disabled={cfont === 'normal'}>
                                    <span  className="header__access-size">
                                      {lang[clang].font_default}
                                      <span className="header__access-size--line"></span>
                                    </span>
                                    <span className="header__access-symbol"></span>
                                  </button>
                                </li>
                                <li className="header__access-list--item">
                                  <button onClick={() => setFontSize('medium')}
                                  title={lang[clang].font_medium}
                                  disabled={cfont === 'medium'}>
                                    <span  className="header__access-size">
                                      {lang[clang].font_medium}
                                      <span className="header__access-size--line"></span>
                                    </span>
                                    <span className="header__access-symbol"></span>
                                  </button>
                                </li>
                                <li className="header__access-list--item">
                                  <button onClick={() => setFontSize('big')}
                                  title={lang[clang].font_big}
                                  disabled={cfont === 'big'}>
                                    <span  className="header__access-size">
                                      {lang[clang].font_big}
                                      <span className="header__access-size--line"></span>
                                    </span>
                                    <span className="header__access-symbol"></span>
                                  </button>
                                </li>
                            </ul>}
                          {type === 'contrast' &&
                              <ul className="header__access-contrast" ref={node => { this.node = node; }}>
                                  <span className="header__access-circle"></span>
                                  <li className="header__access-contrast--item">
                                      <button onClick={() => setContrast('normal')}
                                      title={lang[clang].contrast_default}
                                      disabled={contrast === 'normal'}>
                                          <span  className="header__access-size">
                                              {lang[clang].contrast_default}
                                              <span className="header__access-size--line"></span>
                                          </span>
                                          <span className="header__access-contrast--symbol"></span>
                                      </button>
                                  </li>
                                  <li className="header__access-contrast--item">
                                      <button onClick={() => setContrast('contrast')}
                                      title={lang[clang].contrast_black_yellow}
                                      disabled={contrast === 'contrast'}>
                                          <span className="header__access-contrast--size">
                                              {lang[clang].contrast_black_yellow}
                                              <span className="header__access-contrast--line"></span>
                                          </span>
                                          <span className="header__access-contrast--symbol"></span>
                                      </button>
                                  </li>
                              </ul>}
                    </div>}
            </div>
        );
    };
};

HeaderAccessItem.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(HeaderAccessItem);



// WEBPACK FOOTER //
// ./src/components/header/HeaderAccessItem.js